import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { JSX, ReactNode } from "react";

/** Inline error banner shared by the role-matrix load + save failure paths.
 * Extracted from `RolesPanel.tsx`. */
export function ErrorBanner({ children }: { children: ReactNode }): JSX.Element {
  return (
    <Box
      role="alert"
      sx={{
        display: "grid",
        gap: 1,
        borderRadius: 1,
        border: 1,
        borderColor: (t) => alpha(t.palette.error.main, 0.4),
        bgcolor: (t) => alpha(t.palette.error.main, 0.12),
        px: 1.5,
        py: 1.5,
        fontSize: 14,
        color: "error.main",
      }}
    >
      {children}
    </Box>
  );
}
